import { render } from "./LabApp.vue?vue&type=template&id=c5f8f548&scoped=true&ts=true"
import script from "./LabApp.vue?vue&type=script&lang=ts"
export * from "./LabApp.vue?vue&type=script&lang=ts"

import "./LabApp.vue?vue&type=style&index=0&id=c5f8f548&lang=scss"
import "./LabApp.vue?vue&type=style&index=1&id=c5f8f548&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f8f548"]])

export default __exports__